<div class="text-center" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="32px">
  <section fxLayout fxLayoutAlign="start center" fxLayoutGap="9px">
    <svg class="bc-logo" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.4324 17.2981L7.35882 17.2952V13.7521C7.35882 12.995 7.66343 12.601 8.33539 12.511H10.4324C11.9279 12.511 12.8953 13.42 12.8953 14.8913C12.8953 16.4024 11.9524 17.2967 10.4324 17.2981H10.4324ZM7.35882 7.74154V6.8089C7.35882 5.99285 7.71699 5.60474 8.50223 5.55457H10.0758C11.4243 5.55457 12.2325 6.33225 12.2325 7.6353C12.2325 8.62696 11.6784 9.78538 10.1247 9.78538H7.35882V7.74154ZM14.357 11.2773L13.8014 10.9763L14.2866 10.5763C14.8514 10.1085 15.7974 9.05638 15.7974 7.24128C15.7974 4.46108 13.5611 2.66811 10.1002 2.66811H6.15112V2.66663H5.7011C4.67555 2.70352 3.85359 3.50778 3.84287 4.5024V20.2776H10.1783C14.0249 20.2776 16.5076 18.2588 16.5076 15.1318C16.5076 13.448 15.7056 12.0092 14.357 11.2773Z"
        fill="#0C3B7C" />
      <path
        d="M18.1583 18.0986C18.1583 16.8935 19.1664 15.9186 20.4086 15.9186C21.6538 15.9186 22.6667 16.8935 22.6667 18.0986C22.6667 19.3022 21.6538 20.2786 20.4085 20.2786C19.1664 20.2786 18.1583 19.3022 18.1583 18.0986Z"
        fill="#00AFF1" />
    </svg>
    <div class="success-separator"></div>

    <img [src]="'assets/iconography/arrow-right.svg'" width="26px" height="26px" />

    <div class="success-separator"></div>

    <svg width="41" height="55" viewBox="0 0 41 55" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.5 41.6931C31.8218 41.6931 41 32.496 41 21.1507C41 9.80552 31.8218 0.608398 20.5 0.608398C9.17816 0.608398 0 9.80552 0 21.1507C0 32.496 9.17816 41.6931 20.5 41.6931ZM20.5 33.4764C27.2931 33.4764 32.8 27.9581 32.8 21.151C32.8 14.3439 27.2931 8.8256 20.5 8.8256C13.7069 8.8256 8.2 14.3439 8.2 21.151C8.2 27.9581 13.7069 33.4764 20.5 33.4764ZM28.7784 45.8445H12.3454C10.0765 45.8445 8.23715 47.6895 8.23715 49.9654C8.23715 52.2413 10.0765 54.0863 12.3454 54.0863H28.7784C31.0474 54.0863 32.8867 52.2413 32.8867 49.9654C32.8867 47.6895 31.0474 45.8445 28.7784 45.8445Z"
        fill="#ED3C6A" />
    </svg>
  </section>

  <section fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start center">
    <h2>Unable to import property</h2>

    <span class="text-center width-500" *ngIf="failed === 'multipleRooms'">
      We are unable to import your property because we cannot support multi-inventory listings or units at this time.
    </span>

    <span class="text-center width-500" *ngIf="failed === 'pricingType'">
      We are unable to import your property because it does not use standard pricing. Please change your property to
      standard pricing then retry the process
    </span>

    <a
      href="https://help.hospitable.com/en/articles/5388884-what-booking-com-rate-plans-are-supported"
      target="_blank"
      class="text-center link"
      *ngIf="failed === 'pricingType'">
      How do I change to standard pricing?
    </a>

    <span class="text-center width-500" *ngIf="failed === 'iCalsImported'">
      We are unable to import your property because it has one or more iCal feeds already imported into a Booking.com
      account. Please disconnect them and try again.
    </span>

    <span class="text-center" *ngIf="failed === 'specialRequests'">
      You have declined to setup special requests contact on Booking.com
    </span>

    <span class="text-center width-500" *ngIf="failed === 'scheduledDisclaimer'">
      You didn't agree that scheduled messages will not be delivered for guests who already had reservations prior to
      this connection until the guest sends another message
    </span>
  </section>
</div>
<div
  style="margin-top: 42px"
  fxLayout
  fxLayoutGap="24px"
  fxLayoutAlign="center center"
  *ngIf="failed === 'multipleRooms'">
  <button id="connect-success-primary" mat-flat-button (click)="finish()">Finish (take me to properties)</button>
</div>

<div
  style="margin-top: 42px"
  fxLayout
  fxLayoutGap="24px"
  fxLayoutAlign="center center"
  *ngIf="failed === 'pricingType'">
  <button mat-flat-button (click)="progress()">I've changed the pricing</button>
</div>

<div
  style="margin-top: 32px"
  fxLayout
  fxLayoutGap="24px"
  fxLayoutAlign="center center"
  *ngIf="failed === 'iCalsImported'">
  <button mat-flat-button (click)="progress()">I've disconnected the iCals</button>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="center center">
  <button id="connect-another" mat-flat-button (click)="connectAnother()" class="button__secondary">
    Connect another property
  </button>
</div>
